import { useState, useRef, useEffect } from "react";
import { FireIcon } from "@heroicons/react/24/outline";
import "./App.css";

export default function UpwegoChat() {
  const [messages, setMessages] = useState([
    {
      from: "bot",
      text: "Yo anon! It’s UPWEGO 🔥 — pure energy, bullish vibes, and unshakable belief that the market only goes UP. Bitcoin already smashed $120K and we’re just warming up. I’m here to hype, pump, and remind you that ATH is not a dream, it’s the next stop. 🚀",
    },
  ]);
  const [input, setInput] = useState("");
  const containerRef = useRef(null);

  const sendMessage = async () => {
    if (!input.trim()) return;

    const userMessage = { from: "user", text: input };
    setMessages((prev) => [...prev, userMessage]);

    try {
      const res = await fetch("https://openrouter.ai/api/v1/chat/completions", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization:
            "Bearer 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",
          "HTTP-Referer": "http://localhost:3000",
        },
        body: JSON.stringify({
          model: "openai/gpt-4o",
          messages: [
            {
              role: "system",
              content:
                "You are UPWEGO — the ultimate energetic, ultra-bullish mascot of crypto. You believe the market is destined to rise forever and new ATHs are always ahead. Your tone is hyped, optimistic, and motivational with degen energy. You celebrate pumps, ignore dips, and always remind anons that Bitcoin already hit $120K and the sky is just the beginning. You speak like a CT degen who’s certain that UP is the only direction. 🚀🔥",
            },
            { role: "user", content: input },
          ],
        }),
      });

      const data = await res.json();
      console.log("DEBUG:", data);

      const reply = data.choices?.[0]?.message?.content;
      if (reply) {
        setMessages((prev) => [...prev, { from: "bot", text: reply }]);
      } else {
        setMessages((prev) => [
          ...prev,
          {
            from: "bot",
            text: "Bruh… that input didn’t send us UP. Try again, anon 🚀.",
          },
        ]);
      }
    } catch (err) {
      console.error("Fetch error:", err);
      setMessages((prev) => [
        ...prev,
        {
          from: "bot",
          text: "Connection rugged… but we’re still UP, no worries anon. Reload and let’s send it! 🔥",
        },
      ]);
    }

    setInput("");
  };

  useEffect(() => {
    containerRef.current?.scrollTo({
      top: containerRef.current.scrollHeight,
      behavior: "smooth",
    });
  }, [messages]);

  return (
    <div className="chat-wrapper">
      <div className="chat-header">
        <div className="chat-avatar upwego-avatar" />
        <div className="chat-title">UPWEGO</div>
        
        <a
        href="https://t.me/archanewebsite"
        target="_blank"
        rel="noopener noreferrer"
        className="chat-model"
      >
        @archanewebsite
      </a>
      </div>
      <div ref={containerRef} className="chat-body">
        {messages.map((m, i) => (
          <div
            key={i}
            className={`message ${
              m.from === "user" ? "message-user" : "message-ai"
            }`}
          >
            {m.text}
          </div>
        ))}
      </div>
      <div className="chat-footer">
        <input
          className="chat-input"
          placeholder="Ask UPWEGO... we’re going ATH 🚀🔥"
          value={input}
          onChange={(e) => setInput(e.target.value)}
          onKeyDown={(e) => e.key === "Enter" && sendMessage()}
        />
        <button onClick={sendMessage} className="chat-send">
          <FireIcon className="send-icon" />
        </button>
      </div>
    </div>
  );
}
